import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAdminMode } from "@/lib/adminState";
import { AD_CONFIG, isAdminRoute } from "@/lib/ads";

// Module-level flag so the popunder script is injected only once per
// page-load session, even as the user navigates between SPA routes.
let injected = false;

const inject = () => {
  if (injected) return;
  injected = true;
  const s = document.createElement("script");
  s.src = AD_CONFIG.popunderHead;
  s.async = true;
  s.dataset.xrAd = "popunder-head";
  document.head.appendChild(s);
};

export const Popunders = () => {
  const { pathname } = useLocation();
  const adminMode = useAdminMode();
  useEffect(() => {
    if (adminMode) return;
    if (isAdminRoute(pathname)) return;
    inject();
  }, [pathname, adminMode]);
  return null;
};

export default Popunders;
